/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:main
//
// <<Modification History>>
// Version  | Date       | Updated By           | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/21 | 富士通株式会社        | 新規作成
// 01.01.00 | 2024/03/29 | 富士通Japan株式会社   | 令和5年度改修対応（3次リリース）
//================================================================================
 */
import { createApp } from "vue";
import App from './App.vue'
import router from '@/router/router.js'
import store from '@/store/store'
import axios from 'axios'
import VueAxios from 'vue-axios'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { co_outputErrorLog } from '@/common/ajaxUtility.js';
import { STORE_AJAX_INCREMENT_AJAX_COUNT, STORE_AJAX_DECREMENT_AJAX_COUNT } from '@/const/store.js';

library.add(fas, far)

if (process.env.NODE_ENV=='development') {
	axios.interceptors.request.use(function (request) {
		// リクエスト
		store.commit(STORE_AJAX_INCREMENT_AJAX_COUNT);
		if(console){
			console.log('Request: ', JSON.stringify(request));		
			// eslint-disable-line no-console
		}
		return request;
	});
	
	axios.interceptors.response.use(function (response) {
		// レスポンス(成功時)
		store.commit(STORE_AJAX_DECREMENT_AJAX_COUNT);
		if(console){
			console.log('Response: ', JSON.stringify(response));	// eslint-disable-line no-console
		}
		return response;
	}, function (error) {
		// レスポンス(失敗時)
		store.commit(STORE_AJAX_DECREMENT_AJAX_COUNT);
		throw error;
	});
} else {
	axios.interceptors.request.use(function (request) {
		// リクエスト
		store.commit(STORE_AJAX_INCREMENT_AJAX_COUNT);
		return request;
	});
	
	axios.interceptors.response.use(function (response) {
		// レスポンス(成功時)
		store.commit(STORE_AJAX_DECREMENT_AJAX_COUNT);
		return response;
	}, function (error) {
		// レスポンス(失敗時)
		store.commit(STORE_AJAX_DECREMENT_AJAX_COUNT);
		throw error;
	});
}

const app = createApp(App)

// error handling
app.config.errorHandler = async function(err, vm, info) {
	try {
		if (err.name === 'NavigationDuplicated') {
			// routerで遷移する時、同じページに遷移しようとすると起こるエラーを回避
			return;
		}
		// ログ出力＆画面遷移
		await co_outputErrorLog(info + '\n' + err.stack);
	} catch (e) {
		// 処理なし
	}
};
// javaScriptコード内で発生したエラー
window.addEventListener('error', async function(event) {
	try {
		// ログ出力＆画面遷移;
		await co_outputErrorLog(event.error.stack);
	} catch (e) {
		// 処理なし
	}
});
// promiseの処理で発生したエラー
window.addEventListener('unhandledrejection', async function(event) {
	try {
		if (event.reason.indexOf('NavigationDuplicated') != -1) {
			// routerで遷移する時、同じページに遷移しようとすると起こるエラーを回避
			return;
		}
		// ログ出力＆画面遷移
		await co_outputErrorLog(event.reason);
	} catch (e) {
		// 処理なし
	}
});

app.config.devtools = true

//コンポーネントの追加
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(router)
app.use(store)
app.use(VueAxios, axios)

app.mount("#app")